(() => {
  const boot = () => document.querySelectorAll('[data-film-gallery]').forEach(gallery => {
    if (gallery.dataset.galleryReady) return;
    gallery.dataset.galleryReady = 'true';
    const panels = [...gallery.querySelectorAll('[data-gallery-panel]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const strip = gallery.querySelector('[data-gallery-thumbnails]');
    const controller = new AbortController();
    const {signal} = controller;
    const select = (id, focus = false) => {
      if (!panels.some(panel => panel.dataset.galleryPanel === id)) return;
      panels.forEach(panel => {
        const active = panel.dataset.galleryPanel === id;
        panel.hidden = !active;
        if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbnails.forEach(button => {
        const active = button.dataset.galleryThumbnail === id;
        button.setAttribute('aria-pressed', String(active));
        if (!active) return;
        if (focus) button.focus({preventScroll:true});
        if (!strip) return;
        const target = button.getBoundingClientRect();
        const bounds = strip.getBoundingClientRect();
        if (target.left < bounds.left) strip.scrollLeft -= bounds.left - target.left + 2;
        else if (target.right > bounds.right) strip.scrollLeft += target.right - bounds.right + 2;
      });
    };
    thumbnails.forEach((button, index) => {
      button.addEventListener('click', () => select(button.dataset.galleryThumbnail), {signal});
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
        else if (event.key === 'ArrowLeft') next = (index + thumbnails.length - 1) % thumbnails.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = thumbnails.length - 1;
        else return;
        event.preventDefault();
        select(thumbnails[next].dataset.galleryThumbnail, true);
      }, {signal});
    });
    if (panels.length) select(panels.find(panel => !panel.hidden)?.dataset.galleryPanel || panels[0].dataset.galleryPanel);
    const desktop = matchMedia('(min-width: 750px)');
    const measure = () => {
      if (!desktop.matches) { gallery.style.removeProperty('--gallery-sticky-top'); return; }
      const top = Math.min(112, window.innerHeight - gallery.getBoundingClientRect().height - 24);
      gallery.style.setProperty('--gallery-sticky-top', top + 'px');
    };
    const observer = new ResizeObserver(measure);
    observer.observe(gallery);
    window.addEventListener('resize', measure, {passive:true,signal});
    desktop.addEventListener('change', measure, {signal});
    gallery.addEventListener('load', measure, {capture:true,signal});
    measure();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(gallery)) return;
      observer.disconnect();
      controller.abort();
    }, {signal});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
